export default "__VITE_ASSET__DwwuhEwJ__"